import xr from './xr';

export function track (event) {
  if (window.KIOSK_INSTANCE == null) return;

  event['kiosk'] = window.KIOSK;
  event['kiosk_instance'] = window.KIOSK_INSTANCE;
  event['language'] = event['language'] || '';

  xr.configure({
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
  });

  Object.keys(window.TRACKING_EVENT).forEach(key => {
    event[key] = window.TRACKING_EVENT[key];
  });

  xr.post('/api/tracking/', event)
    .then(res => {}, res => console.error('tracking fail', res));

  window.TRACKING_EVENT = {};
}


export function notification (message) {
  if (window.KIOSK_INSTANCE == null) return;

  let data = {
    kiosk_instance: window.KIOSK_INSTANCE,
    message: message,
  }

  xr.configure({
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
  });

  xr.post('/api/notification/', data)
    .then(res => console.info('notification', data),
          res => console.error('notification fail', res));
}


export function heartbeat() {
  if (window.KIOSK_INSTANCE == null) return;

  let data = {
    kiosk_instance: window.KIOSK_INSTANCE,
    version: window.VERSION,
  }

  xr.configure({
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
  });

  xr.post('/api/heartbeat/', data)
    .then(res => {}, res => console.error('heartbeat fail', res));
}

